<div class="mat-dialog-add-skill-container">
  <div class="detail-card-header mat-dialog-add-content">
    <span whFlex class="w-h-header-span">
      <div class="single-header">
        {{ "app.ui.addAlternativeJobProfiles.label" | translate }}
      </div>
    </span>
  </div>
  <mat-divider class="wh-dialog-divider"></mat-divider>
  <div class="mat-dialog-add-content">
    <div class="flex--r-fs gap--16">
      <div class="flex--col flex--grow gap--16">
        <lib-w-h-dropdown
          data-cy="job-profile-dropdown"
          [required]="false"
          [valueLabel]="'app.ui.alternativeJobProfiles.label'"
          [itemKeys]="['name']"
          [dropdownItemDomList]="data.jobProfilesDropdownList$ | async"
          (onDomEvent)="setJobrequirement($event)"
        >
        </lib-w-h-dropdown>
      </div>
    </div>
    <w-h-button-group align="end" mat-dialog-actions>
      <w-h-button
        [text]="'app.cancel.label' | translate | uppercase"
        type="stroked"
        (clicked)="cancel()"
      />
      <w-h-button
        [text]="'app.confirm.label' | translate | uppercase"
        color="accent"
        type="flat"
        dataCy="job-profile-confirm-button"
        (clicked)="confirm()"
      />
    </w-h-button-group>
  </div>
</div>
